import { Flex, Text } from '@chakra-ui/react';

export default function SidebarItem({
	path,
	icon,
	label,
	isSelected,
	actionOnClick,
}: {
	path: string;
	icon: React.ReactNode;
	label: string;
	isSelected: boolean;
	actionOnClick?: () => void;
}) {
	const sidebarItemFontSize = 13;

	return (
		<Flex
			transition="background-color 0.07s"
			fontSize={sidebarItemFontSize}
			padding={2}
			_hover={{
				backgroundColor: 'rgb(61, 213, 152)',
				color: 'white',
			}}
			backgroundColor={isSelected ? 'rgb(61, 213, 152)' : 'transparent'}
			color={isSelected ? 'white' : 'black'}
			cursor={'pointer'}
			flexDirection={'column'}
			gap={2}
			paddingTop={3}
			paddingBottom={3}
			width={'100%'}
			onClick={actionOnClick}
			alignItems={'center'}
			justifyContent={'center'}
			id={path}
		>
			<span>{icon}</span>
			<Text wordBreak={'break-word'} textAlign={'center'}>
				{label}
			</Text>
		</Flex>
	);
}
